(function () {
  if (window.happymamiFlow) return;
  window.happymamiFlow = {
    busy: false,
    reduce: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    headerOffset: function () {
      var extra = 12;
      var chrome = document.querySelector('.hm-chrome');
      if (chrome) {
        var bottom = chrome.getBoundingClientRect().bottom;
        if (bottom > 0) return Math.round(bottom + extra);
      }
      var offset = extra;
      var header =
        document.querySelector('#shopify-section-header') ||
        document.querySelector('.section-header') ||
        document.querySelector('sticky-header');
      if (header) offset += header.getBoundingClientRect().height || 0;
      var announcement = document.querySelector('.announcement-bar-section');
      if (announcement) offset += announcement.getBoundingClientRect().height || 0;
      return Math.round(offset);
    },
    scrollTo: function (el) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.pageYOffset - this.headerOffset();
      if (top < 0) top = 0;
      window.scrollTo({
        top: top,
        behavior: this.reduce() ? 'auto' : 'smooth',
      });
    },
    swap: function (fromEl, toEl, opts) {
      opts = opts || {};
      var flow = this;
      if (flow.busy) {
        flow._swapQueue = flow._swapQueue || [];
        flow._swapQueue.push({ fromEl: fromEl, toEl: toEl, opts: opts });
        return;
      }
      flow.busy = true;
      var reduced = flow.reduce();
      var outMs = reduced ? 0 : opts.outMs != null ? opts.outMs : 280;
      var successEl = opts.successEl || null;
      var successMs = reduced || !successEl ? 0 : opts.successMs != null ? opts.successMs : 750;
      var done = typeof opts.done === 'function' ? opts.done : function () {};

      function finish() {
        flow.busy = false;
        done();
        var queue = flow._swapQueue;
        if (queue && queue.length) {
          var pending = queue.shift();
          flow.swap(pending.fromEl, pending.toEl, pending.opts);
        }
      }

      function enter(el) {
        if (!el) {
          finish();
          return;
        }
        el.hidden = false;
        el.classList.remove('hm-flow-out', 'hm-flow-in');
        el.classList.add('hm-flow-pending');
        el.hidden = false;
        requestAnimationFrame(function () {
          el.classList.remove('hm-flow-pending');
          if (!reduced) el.classList.add('hm-flow-in');
          if (opts.scroll) flow.scrollTo(opts.scrollEl || el);
          finish();
        });
      }

      function hideSuccess() {
        if (!successEl) return;
        successEl.hidden = true;
        successEl.classList.remove('is-play');
      }

      function afterOut() {
        if (fromEl) {
          fromEl.hidden = true;
          fromEl.classList.remove('hm-flow-out');
        }
        if (typeof opts.prepare === 'function') opts.prepare();
        if (successEl && successMs) {
          successEl.hidden = false;
          successEl.classList.remove('is-play');
          void successEl.offsetWidth;
          successEl.classList.add('is-play');
          setTimeout(function () {
            hideSuccess();
            enter(toEl);
          }, successMs);
          return;
        }
        enter(toEl);
      }

      hideSuccess();
      if (fromEl && !fromEl.hidden && outMs) {
        fromEl.classList.remove('hm-flow-in');
        fromEl.classList.add('hm-flow-out');
        setTimeout(afterOut, outMs);
        return;
      }
      afterOut();
    },
    celebrate: function (fromEl, toEl, successEl, opts) {
      opts = opts || {};
      var flow = this;
      var ms = opts.successMs != null ? opts.successMs : 1600;
      if (fromEl) {
        fromEl.hidden = true;
        fromEl.classList.remove('hm-flow-out', 'hm-flow-in', 'hm-flow-pending');
      }
      if (toEl) toEl.hidden = true;
      if (!successEl) {
        if (toEl) toEl.hidden = false;
        if (opts.scrollTo) flow.scrollTo(opts.scrollTo);
        return;
      }
      successEl.hidden = false;
      successEl.classList.remove('is-play');
      void successEl.offsetWidth;
      successEl.classList.add('is-play');
      flow.scrollTo(successEl);
      if (flow._celebrateTimer) window.clearTimeout(flow._celebrateTimer);
      flow._celebrateTimer = window.setTimeout(function () {
        flow._celebrateTimer = null;
        successEl.hidden = true;
        successEl.classList.remove('is-play');
        if (toEl) toEl.hidden = false;
        if (opts.scrollTo) flow.scrollTo(opts.scrollTo);
      }, ms);
    },
  };
})();

(function () {
  function readWizardConfig() {
    var ids = ['happymami-bundle-config', 'happymami-teat-config', 'happymami-pack-config'];
    var best = {};
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (!el) continue;
      try {
        var parsed = JSON.parse(el.textContent || '{}');
        if (parsed && parsed.pharmaUrl) return parsed;
        if (parsed && (parsed.imageMap || parsed.locale)) best = parsed;
      } catch (e) {}
    }
    return best;
  }

  function mountHappymamiWizard() {
    if (window.__happymamiWizardMounted) return;
    var root = document.getElementById('happymami-wizard');
    if (!root) return;
    window.__happymamiWizardMounted = true;

  var config = readWizardConfig();

  // Todas las imágenes salen de los assets del tema (snippet happymami-wizard-images); nada externo.
  var imageMap = config.imageMap || {};
  var imageSize = config.imageSize || {};
  var sizeByUrl = {};
  Object.keys(imageMap).forEach(function (k) {
    if (imageSize[k]) sizeByUrl[imageMap[k]] = imageSize[k];
  });
  var pharmaUrl = config.pharmaUrl || '';
  var language = typeof window.hmStorefrontLang === 'function' ? window.hmStorefrontLang() : 'es';
  if (config.locale) {
    var raw = String(config.locale).toLowerCase().replace('_', '-');
    var first = raw.split('-')[0];
    if (raw === 'pt-br' || first === 'pt') language = 'pt-pt';
    else if (first === 'en' || first === 'fr' || first === 'de' || first === 'it' || first === 'es') language = first;
  }
  var jsonData = null;
  var translation = null;
  var currentcode = [];
  var answers = {};
  var editMode = null;
  var pendingEdit = null;
  var currentstep = null;
  var firstKey = null;
  var stepTransitioning = false;
  var pendingStageId = null;
  var STEP_ANIM_MS = 240;
  var STEP_ORDER = ['M1', 'M2', 'M3', 'M4'];

  function cardNextStep(stepId, card) {
    var raw = card && card.next != null ? String(card.next).trim() : '';
    if (raw && STEP_ORDER.indexOf(raw) !== -1) return raw;
    var index = STEP_ORDER.indexOf(stepId);
    if (index >= 0 && index < STEP_ORDER.length - 1) return STEP_ORDER[index + 1];
    return null;
  }

  var COPY = {
    es: {
      kicker: '¡Configura tus medidas!',
      back: '< Paso anterior',
      faq: {
        M1: '¿Dudas sobre la forma?',
        M2: '¿Cómo medir la longitud?',
        M3: '¿Cómo medir el diámetro?',
      },
    },
    en: {
      kicker: 'Set your measurements!',
      back: '< Previous step',
      faq: {
        M1: 'Questions about the shape?',
        M2: 'How to measure the length?',
        M3: 'How to measure the diameter?',
      },
    },
    fr: {
      kicker: 'Configurez vos mesures !',
      back: '< Étape précédente',
      faq: {
        M1: 'Des doutes sur la forme ?',
        M2: 'Comment mesurer la longueur ?',
        M3: 'Comment mesurer le diamètre ?',
      },
    },
    it: {
      kicker: 'Configura le tue misure!',
      back: '< Passo precedente',
      faq: {
        M1: 'Dubbi sulla forma?',
        M2: 'Come misurare la lunghezza?',
        M3: 'Come misurare il diametro?',
      },
    },
    de: {
      kicker: 'Konfigurieren Sie Ihre Maße!',
      back: '< Vorheriger Schritt',
      faq: {
        M1: 'Fragen zur Form?',
        M2: 'Wie messe ich die Länge?',
        M3: 'Wie messe ich den Durchmesser?',
      },
    },
    'pt-pt': {
      kicker: 'Configura as tuas medidas!',
      back: '< Passo anterior',
      faq: {
        M1: 'Dúvidas sobre a forma?',
        M2: 'Como medir o comprimento?',
        M3: 'Como medir o diâmetro?',
      },
    },
  };

  var M1_MAP = { '1': '3', '2': '1', '3': '4' };
  // Botón «lactancia artificial exclusiva» del paso 1: rellena todos los pasos con 0 (choice 0000) y usa la tetina T4.
  var BOTTLE_ONLY = '0';
  var VALID = {
    M1: ['1', '2', '3'],
    M2: ['1', '2', '3'],
    M3: ['1', '2', '3'],
    M4: ['1', '2', '3'],
  };

  function qs(sel) {
    return root.querySelector(sel);
  }
  function qsa(sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function mediaUrl(file) {
    if (!file) return '';
    if (/^https?:\/\//i.test(file)) return file;
    var key = String(file).split('/').pop();
    if (imageMap[key]) return imageMap[key];
    if (imageMap[file]) return imageMap[file];
    if (window.console) console.warn('[happymami-wizard] imagen sin mapear:', file);
    return '';
  }
  function imgHtml(src, alt, className) {
    return (
      '<img src="' +
      escapeHtml(src) +
      '" alt="' +
      escapeHtml(alt || '') +
      '"' +
      (sizeByUrl[src] ? ' width="' + sizeByUrl[src][0] + '" height="' + sizeByUrl[src][1] + '"' : '') +
      ' loading="' + (className === 'step-media' ? 'eager' : 'lazy') + '" decoding="async"' +
      (className ? ' class="' + className + '"' : '') +
      '>'
    );
  }
  function uiCopy() {
    return COPY[language] || COPY.es;
  }

  function sortCodes(list) {
    return (list || [])
      .filter(function (item) {
        return item && STEP_ORDER.indexOf(item.step) !== -1;
      })
      .sort(function (a, b) {
        return STEP_ORDER.indexOf(a.step) - STEP_ORDER.indexOf(b.step);
      });
  }
  function codeForStep(stepId) {
    var fromCurrent = currentcode.filter(function (item) {
      return item.step === stepId;
    })[0];
    if (fromCurrent) return String(fromCurrent.code);
    if (answers[stepId]) return String(answers[stepId]);
    return '';
  }
  function upsertCode(stepId, code) {
    var found = null;
    currentcode.forEach(function (item) {
      if (item.step === stepId) found = item;
    });
    if (found) found.code = code;
    else currentcode.push({ step: stepId, code: code });
    currentcode = sortCodes(currentcode);
    answers[stepId] = String(code);
  }
  function codesForCompute() {
    var map = {};
    Object.keys(answers).forEach(function (step) {
      map[step] = String(answers[step]);
    });
    currentcode.forEach(function (item) {
      if (item && item.step) map[item.step] = String(item.code);
    });
    return STEP_ORDER.map(function (step) {
      return { step: step, code: map[step] };
    }).filter(function (item) {
      return item.code;
    });
  }
  function computeRef(codes) {
    var first = (codes || []).filter(function (item) {
      return item && item.step === 'M1';
    })[0];
    if (first && String(first.code) === BOTTLE_ONLY) return 'T4';
    var params = {};
    STEP_ORDER.forEach(function (step) {
      var row = (codes || []).filter(function (item) {
        return item && item.step === step;
      })[0];
      if (row && row.code != null && row.code !== '') params[step] = String(row.code);
    });
    for (var i = 0; i < STEP_ORDER.length; i++) {
      var step = STEP_ORDER[i];
      if (VALID[step].indexOf(params[step]) === -1) return '';
    }
    var flow = params.M2 === '1' ? '2' : M1_MAP[String(params.M1)];
    if (!flow) return '';
    return 'T' + flow;
  }

  function buildChoices(codes) {
    var bottleOnly = (codes || []).some(function (item) {
      return item && item.step === 'M1' && String(item.code) === BOTTLE_ONLY;
    });
    return codes.filter(function (item) {
      return !bottleOnly || item.step === 'M1';
    }).map(function (item) {
      var paso = translation.steps[item.step] || {};
      var titulo = paso.summary || paso.stage || item.step;
      var opcion = item.code;
      if (paso.cards && paso.cards.length) {
        var card = paso.cards.filter(function (c) {
          return String(c.code) === String(item.code);
        })[0];
        if (card) opcion = card.summary || card.button_text;
      }
      return { step: item.step, code: item.code, titulo: titulo, opcion: opcion };
    });
  }

  function clearStepMotion() {
    stepTransitioning = false;
    var container = qs('.step-container');
    if (container) {
      container.classList.remove('is-leaving', 'is-entering', 'is-swap');
      container.style.minHeight = '';
    }
  }

  function flushPendingStage() {
    if (!pendingStageId || stepTransitioning) return;
    var nextId = pendingStageId;
    pendingStageId = null;
    showStage(nextId);
  }

  function completeWizard() {
    var codes = codesForCompute();
    var ref = computeRef(codes);
    var choices = buildChoices(codes);
    var fromEdit = editMode === 'one';
    editMode = null;
    pendingStageId = null;
    clearStepMotion();
    if (!ref) {
      alert(typeof window.hmT === 'function' ? window.hmT('wizard.teat_calc_error') : 'No se pudo calcular la tetina. Revisa tus respuestas.');
      return;
    }
    try {
      sessionStorage.setItem('happymami_teat_sku', ref);
      sessionStorage.setItem('happymami_teat_choices', JSON.stringify(choices));
      sessionStorage.setItem('happymami_teat_codes', JSON.stringify(codes));
    } catch (e) {}
    var detail = { teat: ref, ref: ref, choices: choices, codes: codes, fromEdit: fromEdit };
    document.dispatchEvent(
      new CustomEvent('happymami:complete', {
        bubbles: true,
        detail: detail,
      })
    );
  }

  function applyTimeline(stepId) {
    var index = STEP_ORDER.indexOf(stepId);
    if (index < 0) index = 0;
    var total = STEP_ORDER.length;
    var fill = ((index + 0.42) / (total - 1)) * 100;
    if (index >= total - 1) fill = 100;
    root.style.setProperty('--hm-timeline-fill', fill + '%');
    qsa('[data-hm-dot]').forEach(function (dot) {
      var n = Number(dot.getAttribute('data-hm-dot')) - 1;
      dot.classList.toggle('is-done', n < index);
      dot.classList.toggle('is-current', n === index);
      dot.classList.toggle('is-next', n > index);
    });
  }

  function faqImage(stepId, step) {
    if (stepId === 'M1') {
      var opt = step.support && step.support.options && step.support.options[0];
      return mediaUrl((opt && opt.src) || 'M1-faq.webp');
    }
    if (stepId === 'M2' || stepId === 'M3') return mediaUrl(step.src);
    return '';
  }

  function closePopup() {
    var popup = qs('.popup');
    var overlay = qs('.popup-overlay');
    if (popup) popup.hidden = true;
    if (overlay) overlay.hidden = true;
  }

  function openFaq(src, alt) {
    if (!src) return;
    var body = qs('.modal-body');
    var popup = qs('.popup');
    var overlay = qs('.popup-overlay');
    if (body) body.innerHTML = imgHtml(src, alt);
    if (popup) popup.hidden = false;
    if (overlay) overlay.hidden = false;
  }

  function renderStage(stepId) {
    var step = translation.steps[stepId];
    if (!step) {
      stepTransitioning = false;
      return;
    }
    currentstep = stepId;
    applyTimeline(stepId);

    var labels = uiCopy();
    var kicker = qs('[data-hm-kicker]');
    if (kicker && !root.getAttribute('data-hm-kicker-locked')) {
      var existing = (kicker.textContent || '').trim();
      if (existing) root.setAttribute('data-hm-kicker-locked', existing);
    }
    if (kicker) kicker.textContent = root.getAttribute('data-hm-kicker-locked') || labels.kicker;

    var back = qs('.btn-back');
    if (back) {
      back.hidden = currentcode.length === 0 && !editMode;
      back.textContent = labels.back;
    }

    var title = qs('.step-title');
    var info = qs('.step-info');
    var desc = qs('.step-description');
    var cta = qs('.step-call-to-action');
    if (title) title.textContent = step.question || '';
    if (info) {
      info.textContent = step.info || '';
      info.hidden = !step.info;
    }
    if (cta) {
      cta.textContent = step['call-to-action'] || '';
      cta.hidden = !step['call-to-action'];
    }
    if (desc) {
      desc.innerHTML = '';
      (step.description || []).forEach(function (text) {
        desc.innerHTML += escapeHtml(text) + '<br>';
      });
      desc.hidden = !(step.description && step.description.length);
    }

    var container = qs('.step-container');
    if (container) container.className = 'step-container step-' + stepId;

    var horizontal = qs('.step.horizontal');
    var vertical = qs('.step.vertical');
    if (horizontal) {
      horizontal.hidden = true;
      horizontal.innerHTML = '';
    }
    if (vertical) {
      vertical.hidden = true;
      var optionsRoot = qs('.step.vertical .options');
      if (optionsRoot) optionsRoot.innerHTML = '';
    }

    var layout = step.layout;
    var cards = step.cards || [];
    var isGrid = layout === 'horizontal-choice';
    var target = isGrid ? horizontal : vertical;
    if (target) target.hidden = false;

    if (!isGrid && step.src) {
      var placeholder = qs('.step.vertical .img-placeholder');
      if (placeholder) {
        placeholder.innerHTML = imgHtml(mediaUrl(step.src), step.question, 'step-media');
      }
    }

    var optionsRoot = qs('.step.vertical .options');
    cards.forEach(function (card, index) {
      if (card.divider) {
        var divider = document.createElement('div');
        divider.className = 'hmw-or-divider';
        divider.setAttribute('aria-hidden', 'true');
        divider.innerHTML = card.button_text || '';
        if (isGrid) horizontal.appendChild(divider);
        else optionsRoot.appendChild(divider);
        return;
      }
      var code = card.code;
      var next = cardNextStep(stepId, card);
      var text = String(card.button_text || '').replace(/\n/g, '<br>');
      var el;
      if (isGrid) {
        el = document.createElement('button');
        el.type = 'button';
        el.className = 'option box' + (card.skip_rest ? ' full-row' : '');
        el.setAttribute('data-code', code);
        el.setAttribute('data-next', next || '');
        el.innerHTML = card.skip_rest
          ? '<div class="holder no-img"><h3>' + text + '</h3></div>'
          : '<div class="holder">' +
            (card.src ? imgHtml(mediaUrl(card.src), '') : '') +
            '</div><p class="hm-option-label">' +
            text +
            '</p>';
      } else {
        el = document.createElement('button');
        el.type = 'button';
        el.className = 'option btn';
        el.setAttribute('data-code', code);
        el.setAttribute('data-next', next || '');
        el.innerHTML = text;
      }

      el.style.setProperty('--hm-i', String(index));
      if (String(code) === codeForStep(stepId)) el.classList.add('selected');
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (stepTransitioning && next) return;
        if (el.blur) el.blur();
        qsa('.option').forEach(function (opt) {
          opt.classList.remove('selected');
        });
        el.classList.add('selected');
        advanceSelection(stepId, code, next, card);
      });

      if (isGrid) horizontal.appendChild(el);
      else optionsRoot.appendChild(el);
    });

    var faqBtn = qs('.hm-faq-btn');
    var faqLabel = labels.faq[stepId];
    var faqSrc = faqImage(stepId, step);
    if (faqBtn) {
      if (faqLabel && faqSrc) {
        faqBtn.hidden = false;
        faqBtn.textContent = faqLabel;
        faqBtn.onclick = function () {
          openFaq(faqSrc, faqLabel);
        };
      } else {
        faqBtn.hidden = true;
        faqBtn.onclick = null;
      }
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function showStage(stepId, instant) {
    if (!stepId) return;
    if (stepTransitioning && !instant) {
      pendingStageId = stepId;
      return;
    }
    pendingStageId = null;
    var container = qs('.step-container');
    var prev = currentstep;

    if (instant || !container || prefersReducedMotion() || !prev || prev === stepId) {
      stepTransitioning = false;
      clearStepMotion();
      renderStage(stepId);
      flushPendingStage();
      return;
    }

    stepTransitioning = true;
    var fromH = container.offsetHeight;
    container.style.minHeight = fromH + 'px';
    container.classList.remove('is-entering', 'is-swap');
    container.classList.add('is-leaving');

    window.setTimeout(function () {
      if (document.activeElement && root.contains(document.activeElement) && document.activeElement.blur) {
        document.activeElement.blur();
      }
      renderStage(stepId);
      container.classList.remove('is-leaving');
      void container.offsetWidth;
      container.classList.add('is-entering');
      container.style.minHeight = container.scrollHeight + 'px';
      window.setTimeout(function () {
        container.classList.remove('is-entering');
        container.style.minHeight = '';
        stepTransitioning = false;
        flushPendingStage();
      }, 460);
    }, 250);
  }

  function advanceSelection(stepId, code, next, card) {
    if (code == null || code === '') return;
    code = String(code);
    upsertCode(stepId, code);
    if (card && card.skip_rest) {
      var fill = String(card.fill_remaining != null ? card.fill_remaining : '0');
      STEP_ORDER.forEach(function (step) {
        if (step !== stepId) upsertCode(step, fill);
      });
      completeWizard();
      return;
    }
    if (stepId === 'M1' && code !== BOTTLE_ONLY) {
      // Si venía de «lactancia artificial exclusiva», los pasos 2-4 estaban a 0: se vuelven a contestar.
      var wasBottle = STEP_ORDER.slice(1).some(function (step) {
        return codeForStep(step) === BOTTLE_ONLY;
      });
      if (wasBottle) {
        STEP_ORDER.slice(1).forEach(function (step) {
          delete answers[step];
          currentcode = currentcode.filter(function (item) {
            return item.step !== step;
          });
        });
        editMode = null;
      }
    }
    if (editMode === 'one' || !next) {
      completeWizard();
      return;
    }
    if (stepTransitioning) {
      pendingStageId = next;
      return;
    }
    showStage(next);
  }

  // Enlace con el wizard ya contestado: ?choice=3333&ref=T4  (0000 = lactancia artificial exclusiva)
  //   choice = una cifra (1-3) por paso, en orden: la primera es la opción del paso 1, y así hasta el último.
  //   ref    = tipo de tetina (T1-T4); si falta, se calcula con las respuestas.
  // Se salta el wizard y se deja el resumen con esas elecciones, como si se hubiera completado.
  function readUrlPreset() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return null;
    }
    var choice = String(params.get('choice') || '').replace(/\D/g, '');
    if (choice.length !== STEP_ORDER.length) return null;
    var codes = [];
    var allZero = /^0+$/.test(choice);
    for (var i = 0; i < STEP_ORDER.length; i++) {
      var step = STEP_ORDER[i];
      var code = choice.charAt(i);
      if (allZero) {
        codes.push({ step: step, code: BOTTLE_ONLY });
        continue;
      }
      if (VALID[step].indexOf(code) === -1) return null;
      codes.push({ step: step, code: code });
    }
    var ref = String(params.get('ref') || '')
      .toUpperCase()
      .match(/^T[1-4]/);
    return { codes: codes, ref: ref ? ref[0] : '' };
  }

  function applyUrlPreset(preset) {
    preset.codes.forEach(function (item) {
      upsertCode(item.step, item.code);
    });
    var codes = codesForCompute();
    var ref = preset.ref || computeRef(codes);
    if (!ref) return false;
    var choices = buildChoices(codes);
    try {
      sessionStorage.setItem('happymami_teat_sku', ref);
      sessionStorage.setItem('happymami_teat_choices', JSON.stringify(choices));
      sessionStorage.setItem('happymami_teat_codes', JSON.stringify(codes));
    } catch (e) {}
    var detail = { teat: ref, ref: ref, choices: choices, codes: codes, fromEdit: true };
    var tries = 0;
    // La ficha monta su resumen al cargar: se espera a que el documento y ese resumen estén listos.
    (function send() {
      var teat = document.getElementById('happymami-teat');
      var pending = document.readyState === 'loading' || (teat && typeof teat._hmShowAfter !== 'function');
      if (pending && tries < 40) {
        tries += 1;
        window.setTimeout(send, 100);
        return;
      }
      document.dispatchEvent(new CustomEvent('happymami:complete', { bubbles: true, detail: detail }));
    })();
    return true;
  }

  function boot(data) {
    jsonData = data;
    if (!jsonData[language]) language = 'es';
    translation = jsonData[language];
    firstKey = translation.steps.M1 ? 'M1' : STEP_ORDER[0];
    publishLocalizedChoices();
    var preset = pendingEdit ? null : readUrlPreset();
    if (preset && applyUrlPreset(preset)) return;
    if (pendingEdit) {
      applyEdit(pendingEdit);
      pendingEdit = null;
      return;
    }
    showStage(firstKey);
  }

  function publishLocalizedChoices() {
    window.happymamiLocalizeChoices = function (choices) {
      if (!translation || !translation.steps || !Array.isArray(choices)) return choices || [];
      var storedCodes = [];
      try {
        storedCodes = JSON.parse(sessionStorage.getItem('happymami_teat_codes') || '[]');
      } catch (e) {}
      var localized = choices.map(function (item, index) {
        if (!item) return item;
        var stepId = item.step || STEP_ORDER[index];
        var paso = translation.steps[stepId] || {};
        var code = item.code != null && item.code !== '' ? String(item.code) : '';
        if (!code) {
          var stored = (storedCodes || []).filter(function (row) {
            return row && row.step === stepId;
          })[0];
          if (stored && stored.code != null) code = String(stored.code);
        }
        var card = code
          ? (paso.cards || []).filter(function (entry) {
              return String(entry.code) === code;
            })[0]
          : null;
        return {
          step: stepId,
          code: code,
          titulo: paso.summary || paso.stage || item.titulo || stepId,
          opcion: card ? card.summary || card.button_text : item.opcion,
        };
      });
      try {
        var next = JSON.stringify(localized);
        if (sessionStorage.getItem('happymami_teat_choices') !== next) {
          sessionStorage.setItem('happymami_teat_choices', next);
        }
      } catch (e) {}
      return localized;
    };
    document.dispatchEvent(new CustomEvent('happymami:pharma-ready'));
  }

  function codesFromChoices(choices) {
    if (!translation || !translation.steps) return [];
    return STEP_ORDER.map(function (stepId, index) {
      var paso = translation.steps[stepId] || {};
      var list = Array.isArray(choices) ? choices : [];
      var row =
        list.filter(function (item) {
          return item && (item.step === stepId || item.titulo === (paso.summary || paso.stage));
        })[0] || list[index];
      if (!row) return null;
      if (row.code != null && row.code !== '') return { step: stepId, code: String(row.code) };
      var needle = String(row.opcion || '')
        .replace(/\n/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      var card = (paso.cards || []).filter(function (item) {
        return (
          String(item.button_text || '')
            .replace(/\n/g, ' ')
            .replace(/\s+/g, ' ')
            .trim() === needle
        );
      })[0];
      if (card) return { step: stepId, code: String(card.code) };
      return null;
    }).filter(Boolean);
  }

  function applyEdit(detail) {
    detail = detail || {};
    editMode = detail.mode === 'one' ? 'one' : 'all';
    if (editMode === 'one' && detail.step && STEP_ORDER.indexOf(detail.step) === -1) {
      editMode = null;
      document.dispatchEvent(new CustomEvent('happymami:cancel-edit', { bubbles: true }));
      return;
    }
    var codes = sortCodes(detail.codes || []);
    if (!codes.length) codes = codesFromChoices(detail.choices);
    answers = {};
    codes.forEach(function (item) {
      if (item && item.step && item.code != null) answers[item.step] = String(item.code);
    });
    if (editMode === 'one' && detail.step && translation && translation.steps[detail.step]) {
      currentcode = codes.map(function (item) {
        return { step: item.step, code: item.code };
      });
      showStage(detail.step, true);
      return;
    }
    currentcode = [];
    showStage(firstKey || 'M1', true);
  }

  var overlay = qs('.popup-overlay');
  var closeBtn = qs('.popup .btn-close');
  if (overlay) overlay.addEventListener('click', closePopup);
  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  var back = qs('.btn-back');
  if (back) {
    back.addEventListener('click', function (e) {
      e.preventDefault();
      if (editMode === 'one' || (editMode === 'all' && currentcode.length === 0)) {
        editMode = null;
        document.dispatchEvent(new CustomEvent('happymami:cancel-edit', { bubbles: true }));
        return;
      }
      if (!currentcode.length) return;
      var last = currentcode.pop();
      if (last && last.step) delete answers[last.step];
      showStage(last.step);
    });
  }

  document.addEventListener('happymami:edit', function (event) {
    var detail = (event && event.detail) || {};
    if (!translation) {
      pendingEdit = detail;
      loadPharma();
      return;
    }
    applyEdit(detail);
  });

  document.addEventListener('happymami:restart', function () {
    root = document.getElementById('happymami-wizard') || root;
    currentcode = [];
    answers = {};
    editMode = null;
    if (firstKey) showStage(firstKey);
    else loadPharma();
  });

  function loadPharma() {
    if (window.HAPPYMAMI_PHARMA) {
      boot(window.HAPPYMAMI_PHARMA);
      return;
    }
    if (!pharmaUrl) return;
    fetch(pharmaUrl, { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(boot)
      .catch(function () {});
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadPharma, { timeout: 1200 });
  } else {
    loadPharma();
  }
  }

  mountHappymamiWizard();
  if (!window.__happymamiWizardMounted) {
    document.addEventListener('DOMContentLoaded', mountHappymamiWizard);
    document.addEventListener('product-info:loaded', mountHappymamiWizard);
  }
})();
